import { ReactComponent as home } from "./images/home.svg";
import { ReactComponent as home1 } from "./images/home1.svg";
import { ReactComponent as media } from "./images/media.svg";
import { ReactComponent as basket } from "./images/basket.svg";

export const Icons = {
  home,
  home1,
  media,
  basket,
};
